import {
   Radio,
   RadioGroup,
   FormControl,
   FormControlLabel,
   FormLabel,
   RadioGroupProps,
} from '@mui/material'
import React from 'react'
import { FieldContainer } from '../functional'
import styled from '@emotion/styled'
import { color } from '../../styles'

interface Props extends RadioGroupProps {
   label?: string
   options: { content: React.ReactNode | string; value: string; disabled?: boolean }[]
   className?: string
   name: string
   color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
}

const RadioButtons: React.FC<Props> = ({ label, options, className, name, color, ...props }) => {
   return (
      <FieldContainer name={name}>
         {(fieldProps) => (
            <Holder className={className}>
               <FormControl color={color}>
                  <FormLabel>{label}</FormLabel>
                  <RadioGroup {...fieldProps} {...props}>
                     {options.map((option, index) => {
                        return (
                           <FormControlLabel
                              key={index}
                              value={option.value}
                              control={<Radio color={color} />}
                              label={option.content}
                              disabled={option.disabled}
                           />
                        )
                     })}
                  </RadioGroup>
               </FormControl>
               {fieldProps.error && <span className="error-text">{fieldProps.helperText}</span>}
               <span className="error-text">Has error</span>
            </Holder>
         )}
      </FieldContainer>
   )
}

const Holder = styled.div`
   display: flex;
   flex-direction: column;
   width: max-content;

   .error-text {
      color: ${color.red};
      font-size: 0.9em;
      margin-top: 0.5em;
   }
`
export default RadioButtons
export type RadioButtonsProps = Props
